import React, { Component } from 'react'
import { PageContainer } from 'smart-components'
import { userIsAuthenticatedRedir } from 'hocs/auth'

import './index.scss'

class QlikTsbKeypointfunctionquery extends Component {

    constructor(props) {
        super(props)
        this.mobileWidth = 0
        this.state = {
            width: window.innerWidth
        }
    }

    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }

    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    }

    render() {
        const url = "https://qlik.unifi.id/external-ticket-authentication/single/?appid=0f7785da-b2a8-4e04-bcee-af764f3826cf&sheet=9c6b4480-ba60-407a-8c2b-e49fe5d27742&opt=currsel%2Cctxmenu&select=clearall"
        return (
            <PageContainer>
                <iframe src={url} />
            </PageContainer>
        )
    }
}

export default userIsAuthenticatedRedir(QlikTsbKeypointfunctionquery)



// WEBPACK FOOTER //
// ./src/pages/qlik-reports/tsbkeypoint/functionquery/index.js